import { createContext, useContext, useState } from 'react';
import { addLessonProgress, sendUpdateLessonProgress } from '../utils';

const StudentContext = createContext();

export const StudentProvider = ({ children }) => {
  const [studentData, setStudentData] = useState({
    courseProgress: {},
    completedLessons: [],
  });

  const updateLessonProgress = (courseId, lessonId, completed) => {
    if (!courseId || !lessonId) return;

    setStudentData((prevStudent) => {
      const newStudentProgress = addLessonProgress(prevStudent, courseId, lessonId, completed);
      sendUpdateLessonProgress(newStudentProgress, courseId);
      return newStudentProgress;
    });
  };

  const value = {
    student: studentData,
    updateLessonProgress,
    setStudentData,
  };

  return <StudentContext.Provider value={value}>{children}</StudentContext.Provider>;
};

export const useStudent = () => {
  const context = useContext(StudentContext);
  if (!context) {
    throw new Error('useStudent must be used within a StudentProvider');
  }
  return context;
};
